import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Numéro de téléphone',
      placeholder: 'Entrez votre numéro de téléphone',
    },
    email: {
      label: 'Adresse e-mail',
      placeholder: 'Saisissez votre adresse e-mail',
    },
  },
  channel_chooser: {
    title: 'Envoyer le code via',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Gratuit, livraison la plus rapide',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'SMS standard',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'E-mail',
      subtitle: 'Le code directement dans votre boîte de réception',
    },
  },
  otp: {
    title: 'Entrez le code de vérification',
    send_code: 'Envoyer le code',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Envoyé via <strong>WhatsApp</strong> au <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Envoyé via <strong>SMS</strong> au <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Envoyé par <strong>e-mail</strong> à <strong>{{phone}}</strong>',
    },
    sent_to: 'Envoyé à',
    resend: {
      title: "Vous n'avez pas reçu le code ?",
      countdown: 'Renvoyer dans',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: "Vous n'avez pas reçu le code par e-mail ?",
          button: 'Renvoyer par e-mail',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: "Vous n'avez pas reçu le code ?",
          button: 'Renvoyer par SMS',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: "Vous n'avez pas reçu le code ?",
          button: 'Renvoyer par WhatsApp',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Envoyer par SMS à la place',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Envoyer par WhatsApp à la place',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'Un message contenant un code de vérification a été envoyé sur votre téléphone. Entrez le code pour continuer.',
      [OTP_DELIVERY_CHANNELS.EMAIL]:
        'Veuillez entrer le code envoyé à cette adresse : <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'Un message WhatsApp contenant un code de vérification a été envoyé sur votre téléphone. Entrez le code pour continuer.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Conseil : vérifiez votre boîte de réception et vos spams.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Attention — le code est envoyé par <strong>{{sender}}</strong>, notre partenaire technologique.',
    business_account: 'Compte professionnel',
    message: '<strong>123456</strong> est votre code de vérification. Pour votre sécurité, ne partagez pas ce code.',
  },
  error_messages: {
    frequent_requests:
      'Veuillez vérifier vos messages. Nous avons déjà envoyé le code au numéro indiqué. Sinon, vérifiez le numéro ou réessayez dans 10 minutes.',
    frequent_requests_email:
      "Veuillez vérifier votre boîte de réception et vos courriers indésirables. Nous avons déjà envoyé le code à cette adresse. S'il n'est pas arrivé, réessayez dans 10 minutes.",
    invalid_number: 'Numéro invalide. Veuillez réessayer.',
    invalid_email: "Nous n'avons pas pu envoyer le code à cette adresse e-mail. Veuillez la vérifier et réessayer.",
    email_not_on_file:
      'Ce numéro de téléphone possède déjà un compte sans adresse e-mail. Veuillez contacter {{support_email}} pour en ajouter une — en attendant, nous ne pouvons pas envoyer de codes pour ce numéro par e-mail.',
    turnstile_required: 'Veuillez compléter la vérification avant de demander un nouveau code.',
    generic_error: "Oups, une erreur s'est produite. Veuillez actualiser la page et réessayer.",
    change_phone_number_unsuccessful: 'Échec de la modification du numéro de téléphone. Veuillez réessayer.',
  },
  toasts: {
    code_sent: 'Code envoyé',
  },
};
